const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const styles = require("./styles/DemoSignupModalButton.css");

module.exports = createReactClass({
	displayName: "DemoSignupModalButton",

	propTypes: {
		onClick: PT.func,
		buttonText: PT.string,
	},

	render: function() {
		return (
			<div className={styles.buttonWrap} onClick={this.props.onClick}>
				<svg
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 181.32 75.17"
					preserveAspectRatio="none"
					className={styles.buttonImage}
				>
					<path
						className={styles.buttonFrame}
						d="M0,5.06,7.9,72.83,176,75.17,181.32,0ZM164.18,63.84,13,66.82,7.41,11.32l164-1.73Z"
					/>
					<path
						className={styles.buttonFrameBackground}
						d="M0,5.06,7.9,72.83,176,75.17,181.32,0Z"
					/>
				</svg>
				<div className={styles.buttonText}>{this.props.buttonText}</div>
			</div>
		);
	},
});
